export enum ArchivingReason {
	DEATH = '2',
}
